import { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { SvgIcon } from '@mui/material';
import { BiTrash } from 'react-icons/bi';
// import { removeEmployee } from 'redux/usersPermissions';
import UsersList from '../UsersList/UsersList';
import { ReactComponent as AddUserIcon } from 'assets/icons/add-user.svg';
import api, { ImmigrationProfessional } from 'api';
import styles from './PermissionsPage.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import * as S from './PermissionsPage.styled';

const PermissionsPage = () => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    // const employeesFromServer = useSelector((state: RootState) => state.employees.list);
    // const dispatch = useDispatch();

    const [selectedUsers, setSelectedUsers] = useState<ImmigrationProfessional[]>([]);
    const [employeesFromServer, setEmployeesFromServer] = useState<ImmigrationProfessional[]>([]);

    const linkRef = useRef<HTMLAnchorElement | null>(null);

    const handleSelectedItems = (checkedList: ImmigrationProfessional[]) => {
        setSelectedUsers(checkedList);
    };

    const imitateAddUserClick = () => {
        if (linkRef) {
            linkRef.current?.click();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        const response = await api.listImmigrationProfessionals.get();
        if (response.status === 200) {
            setEmployeesFromServer(response.data);
        }
    }

    const handleDeleteSelected = async () => {
        const removeUsersId: number[] = selectedUsers.map((user) => user.id);
        removeUsersId.forEach((id) => handleRemove(id));
    };

    const handleRemove = async (id: number) => {
        try {
            await api.immigrationProfessional.deleteProfessional(id.toString());
            fetchData();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className={styles.root}>
            <section className={styles['top-block']}>
                <h1 className={styles.title}>{t('permissions', { lng: language })}</h1>
            </section>

            <div className={styles.buttonContainer}>
                <S.IconButton
                    disableRipple
                    sx={{
                        '&:hover': { opacity: '0.9' },
                    }}
                    onClick={handleDeleteSelected}
                >
                    <SvgIcon
                        style={{ width: '15', height: '16.7px', marginRight: '14.5px' }}
                        viewBox="3 5 18 16.7"
                        component={BiTrash}
                    />
                    <span>{t('deleteSelected', { lng: language })}</span>
                </S.IconButton>
                <NavLink className={styles.navLink} ref={linkRef} to={'add-user'} tabIndex={-1} />
                <S.Button
                    onClick={imitateAddUserClick}
                    variant="outlined"
                    endIcon={<AddUserIcon fill="#282828" />}
                >
                    {t('addCollaborator', { lng: language })}
                </S.Button>
            </div>

            <UsersList
                users={employeesFromServer}
                getSelectedItems={handleSelectedItems}
                removeItemClick={handleRemove}
            />
        </div>
    );
};

export default PermissionsPage;
